var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":_vm.title,"pageName":_vm.pageName}}),_vm._v(" "),(_vm.showContent)?_c('div',{staticClass:"home-content"},[_c('keep-alive',[_c('router-view')],1)],1):_vm._e(),_vm._v(" "),(_vm.showWarn)?_c('div',{staticStyle:{"height":"100vh"}},[_c('EmptyTips',{attrs:{"tipsList":['非乘务员或安全员', '请确认身份！'],"isWarn":""}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcdac756","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = null
// module chunks = 